'use strict';
import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import Dialog from 'rc-dialog';
import Titulo from './Titulo.jsx';
import PagosRegistradosModal from './PagosRegistradosModal/PagosRegistradosModal.jsx';
import MontoMask from "../../../../Common/Components/Mask/MontoMask.jsx"

class PagosRegistrados extends Component {
    constructor(props) {
        super(props);
        this.state = { modalDetallesPagos: false };
    }

    toggleModalDetallesPagos() {
        this.setState({ modalDetallesPagos: !this.state.modalDetallesPagos });
    }

    render() {
        const { pagos, proximoResumen, fechasCierreUltimaCartera, detalleCuenta, origenCanalPago, pagosRegistradosPesos, pagosRegistradosDolares } = this.props;

        return <div>
            <Titulo
                mostrarBoton={false}
                lblBoton={""}
                titulo={"Pagos Registrados"}
            />

            <div className="row section-bordered">
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Importe $:</label>
                        </div>
                        <div className="col-md-6">
                            <MontoMask monto={pagos && pagos.PagosPesos} moneda={"pesos"} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <a className="btn-link btn-link-labeled-primary ti-sm" onClick={() => this.toggleModalDetallesPagos()}>
                                Ver Detalles
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 left-separator">
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Importe U$S:</label>
                        </div>
                        <div className="col-md-6">
                            <MontoMask monto={pagos && pagos.PagosUsd} moneda={"dolares"} />
                        </div>
                    </div>
                </div>
            </div>


            <div>
                <Dialog
                    visible={this.state.modalDetallesPagos}
                    onClose={() => this.toggleModalDetallesPagos()}
                    animation="slide-fade"
                    maskAnimation="fade"
                    style={{
                        width: 892,
                        height: 502
                    }}
                    title="Pagos Registrados"
                    footer={[
                        <button
                            type="button"
                            className="btn btn-default"
                            key="close"
                            onClick={() => this.toggleModalDetallesPagos()}
                        >
                            Cerrar
                    </button>
                    ]}
                >
                    <PagosRegistradosModal fechasCierreUltimaCartera={fechasCierreUltimaCartera}
                        pagosRegistradosPesos={pagosRegistradosPesos}
                        pagosRegistradosDolares={pagosRegistradosDolares} />
                </Dialog>

            </div>

        </div>
    }
}
export default PagosRegistrados;